// extracted by css-extract-rspack-plugin
export default {"container":"_8b61fa56"};